import logo from '../logo.svg';
import { Typography, Paper, AppBar, Button, Box, Card, CardActions, CardContent, CardMedia, CssBaseline, Grid, Link, Toolbar, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import ResponsiveAppBar from './ResponsiveAppBar';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const Imprint = () => {
  return (
    <div className="App">

<ResponsiveAppBar />

      <main>

        <Container maxWidth="lg" className="subPageContainer">
          <Typography variant='h1' className='sectionTitle'>Beglaubigungen</Typography>

          <Box className='subpageBodyBox'>
            <Typography variant='body1' className='sectionText'>
            Verschiedene Stellen im In- und Ausland fordern die Beglaubigung eines Dokuments oder die Beglaubigung einer Unterschrift durch einen Notar. Bei der Beglaubigung einer Abschrift prüft der Notar lediglich, dass das ihm vorgelegte Dokument identisch ist mit der Abschrift, die er erteilt. Bei der Unterschriftenbeglaubigung prüft der Notar nur anhand eines amtlichen Lichtbildausweises, ob die richtige Person das Dokument unterschreibt. In beiden Fällen prüft der Notar nicht, ob das Dokument inhaltlich richtig ist und berät auch grds. nicht zu den rechtlichen Folgen des jeweiligen Rechtsgeschäfts.<br /><br />
            Falls Sie ein Dokument im Ausland verwenden wollen, benötigen Sie dafür meist eine zusätzliche besondere Beglaubigung. Die sog. Apostille erteilt der Präsident des Landgerichts Bonn. Wir können das Dokument beim Landgericht Bonn für Sie einreichen und die Erteilung der Apostille für Sie beantragen. In anderen Ländern ist dagegen die aufwendige Legalisation des Dokuments durch ein Konsulat erforderlich. Bitte stimmen Sie vorab mit den ausländischen Stellen ab, welche Art von Nachweis diese verlangen.
            </Typography>

            <Button className='btnSecondary'><HashLink smooth to="#">Formulare Beglaubigungen</HashLink></Button>
          </Box>
        </Container>


<Box className="section bannergrey" id="kontakt">
          <Container maxWidth="lg" className="container" id="kontakt">
            <Box className="kontaktGrid">
              <Box className="kontaktLeftSide">
                <Typography variant='h2' className='sectionTitle white'>
                  Sie haben Fragen?  <br />
                  Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                </Typography>
                <Typography variant='body1' paragraph className='whiteText'>
                  Harbecke & Thelen Notare<br />
                  Holzgasse 29 - 33<br />
                  Siegburg 53721<br />
                </Typography>
              </Box>
              <Contactform />
            </Box>
          </Container>
        </Box>

        
      </main >
      <Footer />
    </div >

   
  );
}

export default Imprint;